export const searchFormOption = function () {
    return [
		{
		  prop: "keyword",
		  label: "关键字",
		  type: "input",
		  placeholder: "流水号/被服人/车牌号/车架号",
		  width: "20%",
		},
		{
		    prop: 'date',
		    label: '提交日期',
		    type: 'range-date',
		},
        {
            prop: 'orgId',
            label: '出单机构',
            type: 'cascader',
            placeholder: '请选择出单机构',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.orgOption
        },
		{
		  prop: "CreatorNo",
		  label: "制单人",
		  type: "select",
		  width: "20%",
		  options: this.creatorNoList,
		},
		{
		  prop: "status",
		  label: "状态",
		  type: "select",
		  width: "20%",
		  options: this.$emun.status,
		},
    ]
}

export default {}